<template>
 <div>
        <div> <el-link type="primary"><router-link to="/books_xr">候选书单</router-link></el-link></div>
        <div>该教辅对应的题目数据(详情)</div>
        <el-table
            ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
            <el-table-column
                    prop="bookName"
                    label="书名"
                    width="260">
            </el-table-column>
            
        </el-table>
        <div style="margin-top: 20px">
            <el-button @click="toggleSelection()">刷新</el-button>
        </div>
  </div>
</template>

<script>

import {sync_books_list } from '@/api/xrsync';
import {MessageBox,Message } from 'element-ui';


  export default {
    data() {
      return {
        tableData: [],
        multipleSelection: []
      }
    },

    mounted : function() {
        this.load_sync_books();
    },

    methods: {

        load_sync_books:function(){
            sync_books_list().then(resp =>{
                console.log(resp);
                this.tableData = resp.data;
            });
        },

        toggleSelection(rows) {
            if (rows) {
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
            } else {
            this.$refs.multipleTable.clearSelection();
            }
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/xrbs/questions.vue